import React, { useEffect, useState } from 'react';
const comparisonRows = [{
  without: 'Improvisás qué enseñar cada vez que llegás al dojo',
  with: 'Plan técnico de 48 semanas listo para ejecutar'
}, {
  without: 'Alumnos que se van sin avisarte cada mes',
  with: 'Sistema de retención que frena la deserción'
}, {
  without: 'Horas perdidas pensando qué clase dar hoy',
  with: '+600 páginas de sistema listas para implementar'
}, {
  without: 'Clases sin estructura que no generan progreso visible',
  with: 'Metodología pedagógica que retiene y fideliza'
}, {
  without: 'Sin saber si tus alumnos avanzan o se frustran',
  with: 'Sistema de grados claro que motiva semana a semana'
}, {
  without: 'Culpa por cobrar poco y no saber cómo subir',
  with: 'Sistema de cobros y precios que cierra a fin de mes'
}, {
  without: 'Cero alumnos nuevos sin gastar en publicidad',
  with: 'Marketing orgánico que capta sin invertir un peso'
}, {
  without: 'El dojo se para si vos no estás presente',
  with: 'Monitores formados y sistema que funciona solo'
}, {
  without: 'Trabajás 6 días y el número no refleja el esfuerzo',
  with: 'Ingreso pasivo digital que crece mientras enseñás'
}];
export function DarkCTA() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 26,
    seconds: 56
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) return {
          hours: 0,
          minutes: 0,
          seconds: 0
        };
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <section className="w-full px-4 py-16 sm:py-20 text-base leading-6" style={{
    backgroundColor: 'rgb(30, 10, 14)',
    backgroundImage: 'linear-gradient(180deg, rgb(20, 5, 8) 0%, rgb(10, 10, 10) 50%, rgb(20, 5, 8) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-62">
      <div className="mx-auto max-w-4xl text-center" data-id="element-63">
        {/* MARCA */}
        <div className="mb-8 text-2xl sm:text-3xl font-black tracking-[3px] text-red-500" data-id="element-64">
          🥋 MEGAPACK ARTES MARCIALES™
        </div>

        {/* HEADLINE */}
        <h2 className="text-xl sm:text-3xl font-bold text-gray-300 m-0 mb-3" data-id="element-65">
          Esta semana podés seguir improvisando tus clases.
        </h2>
        <p className="text-xl sm:text-3xl font-black text-red-500 m-0 mb-10" data-id="element-66">
          O podés tener un sistema profesional funcionando desde hoy.
        </p>

        {/* TABLA COMPARATIVA */}
        <div className="mx-auto max-w-2xl mb-12 overflow-hidden rounded-2xl border border-red-900 text-left" style={{
        backgroundColor: 'rgb(15, 5, 5)'
      }} data-id="element-67">
          <div className="text-center font-bold text-white border-b border-red-900 px-4 py-4" style={{
          backgroundColor: 'rgb(20, 5, 5)'
        }} data-id="element-68">
            ¿Cuánto te cuesta NO tenerlo?
          </div>

          <div className="grid grid-cols-2 border-b border-red-900" style={{
          backgroundColor: 'rgb(20, 5, 5)'
        }} data-id="element-69">
            <div className="text-center font-bold text-gray-500 px-4 py-3 text-sm" data-id="element-70">
              SIN MEGAPACK
            </div>
            <div className="text-center font-bold text-red-500 border-l border-red-900 px-4 py-3 text-sm" data-id="element-71">
              CON MEGAPACK
            </div>
          </div>

          {comparisonRows.map((row, i) => <div key={i} className={`grid grid-cols-2 ${i < comparisonRows.length - 1 ? 'border-b border-gray-800' : ''}`} data-id="element-72">
              <div className="px-4 py-3 text-xs sm:text-sm text-gray-500" data-id="element-73">
                ✗ {row.without}
              </div>
              <div className="px-4 py-3 text-xs sm:text-sm font-bold text-gray-200 border-l border-gray-800" style={{
            backgroundColor: 'rgba(196, 30, 58, 0.08)'
          }} data-id="element-74">
                ✅ {row.with}
              </div>
            </div>)}
        </div>

        {/* COUNTDOWN */}
        <div className="mb-4" data-id="element-75">
          <p className="font-bold text-gray-300 m-0 mb-4" data-id="element-76">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <div className="flex items-center justify-center gap-0" data-id="element-77">
            <div className="flex flex-col items-center" data-id="element-78">
              <span className="text-5xl sm:text-7xl font-black tabular-nums animate-countdown-blink will-change-[opacity] text-red-500" data-id="element-79">
                {pad(timeLeft.hours)}
              </span>
              <span className="text-xs sm:text-sm uppercase tracking-wide text-gray-500" data-id="element-80">
                hs
              </span>
            </div>
            <span className="mb-4 text-5xl sm:text-7xl font-black animate-countdown-blink will-change-[opacity] text-red-500" data-id="element-81">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-82">
              <span className="text-5xl sm:text-7xl font-black tabular-nums animate-countdown-blink will-change-[opacity] text-red-500" data-id="element-83">
                {pad(timeLeft.minutes)}
              </span>
              <span className="text-xs sm:text-sm uppercase tracking-wide text-gray-500" data-id="element-84">
                min
              </span>
            </div>
            <span className="mb-4 text-5xl sm:text-7xl font-black animate-countdown-blink will-change-[opacity] text-red-500" data-id="element-85">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-86">
              <span className="text-5xl sm:text-7xl font-black tabular-nums animate-countdown-blink will-change-[opacity] text-red-500" data-id="element-87">
                {pad(timeLeft.seconds)}
              </span>
              <span className="text-xs sm:text-sm uppercase tracking-wide text-gray-500" data-id="element-88">
                seg
              </span>
            </div>
          </div>
        </div>

        <p className="text-sm text-gray-500 m-0 mb-12" data-id="element-89">
          Después sube{' '}
          <span className="font-bold text-red-500" data-id="element-90">$8.000 ARS</span> y no
          vuelve.
        </p>

        {/* CARDS DE PRECIO */}
        <div className="mx-auto max-w-2xl mb-10 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-91">
          {/* OPCIÓN 1 */}
          <div className="flex flex-col rounded-xl p-6 border border-gray-800 shadow-sm" style={{
          backgroundColor: 'rgb(20, 10, 10)'
        }} data-id="element-92">
            <div className="mb-2 text-2xl" data-id="element-93">🥋</div>
            <h3 className="text-base font-black text-white m-0 mb-1" data-id="element-94">
              MEGAPACK ARTES MARCIALES
            </h3>
            <p className="text-xs text-gray-500 m-0 mb-4" data-id="element-95">
              6 Tomos + 6 Bonos · +600 páginas · Sistema Maestro completo
            </p>
            <div className="mt-auto" data-id="element-96">
              <p className="text-sm text-gray-600 line-through m-0 mb-1" data-id="element-97">
                Antes: $49.990 ARS
              </p>
              <p className="text-2xl font-black text-white m-0 mb-4" data-id="element-98">
                Hoy: $19.990 ARS
              </p>
              <a href="https://checkout.construyeprogreso.com/cart/48217959366826:1" onClick={() => {
              if (typeof window !== 'undefined' && (window as any).fbq) {
                ;
                (window as any).fbq('track', 'InitiateCheckout', {
                  content_name: 'Megapack Artes Marciales',
                  content_category: 'Artes Marciales',
                  value: 19990,
                  currency: 'ARS'
                });
              }
            }} className="block text-white text-center text-sm font-black rounded-lg py-4 no-underline transition-transform active:scale-95 will-change-transform" style={{
              background: 'linear-gradient(135deg, rgb(153, 0, 0) 0%, rgb(196, 30, 58) 50%, rgb(220, 50, 80) 100%)',
              boxShadow: '0 8px 32px rgba(196, 30, 58, 0.4)'
            }} data-id="element-99">
                🥋 QUIERO MI MEGAPACK →
              </a>
            </div>
          </div>

          {/* OPCIÓN 2 — UPSELL */}
          <div className="flex flex-col rounded-xl p-6 border-2 border-red-600 shadow-sm" style={{
          backgroundColor: 'rgb(25, 5, 5)',
          boxShadow: 'rgba(196, 30, 58, 0.2) 0px 0px 30px 0px'
        }} data-id="element-100">
            <div className="mb-2 text-2xl" data-id="element-101">🏆</div>
            <h3 className="text-base font-black text-red-500 m-0 mb-1" data-id="element-102">
              MEGAPACK + ACADEMIA ONLINE™ ⭐
            </h3>
            <p className="text-xs text-gray-500 m-0 mb-1" data-id="element-103">La más elegida</p>
            <p className="text-xs text-gray-500 m-0 mb-4" data-id="element-104">
              6 Tomos + 6 Bonos + Academia Online™
              <br data-id="element-105" />
              (grabación + plataforma + lanzamiento + ingreso pasivo)
            </p>
            <div className="mt-auto" data-id="element-106">
              <p className="text-sm text-gray-600 line-through m-0 mb-1" data-id="element-107">
                Antes: $64.990 ARS
              </p>
              <p className="text-3xl font-black text-red-500 m-0 mb-4" data-id="element-108">
                Hoy: $27.990 ARS
              </p>
              <a href="https://checkout.construyeprogreso.com/cart/48217960120490:1" onClick={() => {
              if (typeof window !== 'undefined' && (window as any).fbq) {
                ;
                (window as any).fbq('track', 'InitiateCheckout', {
                  content_name: 'Megapack Artes Marciales + Academia Online™',
                  content_category: 'Artes Marciales',
                  value: 27990,
                  currency: 'ARS'
                });
              }
            }} className="block text-white text-center text-sm font-black rounded-lg py-4 no-underline transition-transform active:scale-95 will-change-transform" style={{
              background: 'linear-gradient(135deg, rgb(153, 0, 0) 0%, rgb(196, 30, 58) 50%, rgb(220, 50, 80) 100%)',
              boxShadow: '0 8px 32px rgba(196, 30, 58, 0.4)'
            }} data-id="element-109">
                🥋 QUIERO EL MEGAPACK + ACADEMIA ONLINE™ →
              </a>
            </div>
          </div>
        </div>

        {/* GARANTÍAS */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-500" data-id="element-110">
          <span data-id="element-111">🔒 Pago 100% seguro</span>
          <span data-id="element-112">⚡ Acceso en 5 minutos</span>
          <span data-id="element-113">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-114">💳 Mercado Pago | Tarjeta | Transferencia</span>
        </div>
      </div>
    </section>;
}